import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { createHttpVossClient } from "./lib/vossClient";
import { VossProvider } from "./state/VossProvider";
import "./styles/app.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root was not found in index.html");

createRoot(container).render(
  <StrictMode>
    <VossProvider client={createHttpVossClient()}>
      <App />
    </VossProvider>
  </StrictMode>,
);
